import { render, staticRenderFns } from "./Combo.vue?vue&type=template&id=2e39bfe8&scoped=true&"
import script from "./Combo.vue?vue&type=script&lang=js&"
export * from "./Combo.vue?vue&type=script&lang=js&"
import style0 from "./Combo.vue?vue&type=style&index=0&id=2e39bfe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e39bfe8",
  null
  
)

component.options.__file = "Combo.vue"
export default component.exports